import React, { useEffect, createElement } from 'react';
import { KidsKarateHeroInfo } from './kids-karate/KidsKarateHeroInfo';
import { KidsKarateHeroForm } from './kids-karate/KidsKarateHeroForm';
import { KidsKarateBridge } from './kids-karate/KidsKarateBridge';
import { KidsKarateBenefits } from './kids-karate/KidsKarateBenefits';
import { KidsKarateWhatYouLearn } from './kids-karate/KidsKarateWhatYouLearn';
import { KidsKarateReviews } from './kids-karate/KidsKarateReviews';
import { KidsKarateScheduleLocation } from './kids-karate/KidsKarateScheduleLocation';
import { KidsKarateFAQHeader } from './kids-karate/KidsKarateFAQHeader';
import { KidsKarateFAQQuestions } from './kids-karate/KidsKarateFAQQuestions';
import { KidsKarateFAQActions } from './kids-karate/KidsKarateFAQActions';
import { KidsKarateRelatedLinks } from './kids-karate/KidsKarateRelatedLinks';
import { KidsKarateFinalCTA } from './kids-karate/KidsKarateFinalCTA';
export function KidsKarate() {
  useEffect(() => {
    document.title = 'Kids Karate Classes Near Farmington Hills | Storm Taekwondo';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Looking for kids karate near Farmington Hills? Storm Taekwondo teaches Olympic-style martial arts for confidence, focus and discipline. Try a free week.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Looking for kids karate near Farmington Hills? Storm Taekwondo teaches Olympic-style martial arts for confidence, focus and discipline. Try a free week.';
      document.head.appendChild(meta);
    }
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-2296">
      <section className="relative bg-ink pt-12 pb-24 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-2297">
        <div className="absolute inset-0 opacity-20" data-id="element-2298">
          <img src="https://images.unsplash.com/photo-1555597673-b21d5c935865?auto=format&fit=crop&w=2000&q=80" alt="Taekwondo Background" className="block w-full h-full object-cover" data-id="element-2299" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-transparent" data-id="element-2300" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2301">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-2302">
            <KidsKarateHeroInfo data-id="element-2303" />

            <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto" data-id="element-2304">
              <KidsKarateHeroForm data-id="element-2305" />
            </div>
          </div>
        </div>
      </section>
      <KidsKarateBridge data-id="element-2306" />
      <KidsKarateBenefits data-id="element-2307" />
      <KidsKarateWhatYouLearn data-id="element-2308" />
      <KidsKarateReviews data-id="element-2309" />
      <KidsKarateScheduleLocation data-id="element-2310" />
      <section className="py-24 bg-off-white" data-id="element-2311">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2312">
          <KidsKarateFAQHeader data-id="element-2313" />
          <KidsKarateFAQQuestions data-id="element-2314" />
          <KidsKarateFAQActions data-id="element-2315" />
        </div>
      </section>
      <KidsKarateRelatedLinks data-id="element-2316" />
      <KidsKarateFinalCTA data-id="element-2317" />
    </div>;
}